import { useLang } from '@/i18n';
import EfModal from '@elem/ui/ef-modal';
import EfSection from '@elem/ui/ef-section';
import EfSpec from '@elem/ui/ef-spec';
import EfTabSection from '@elem/ui/ef-tab-section';
import { useState } from 'react';
import styles from './index.module.scss';
import Win1 from './Win1';
import Win3 from './Win3';

export default function TheComp() {
    const { t } = useLang('theProduct.TabA');
    // 点击更多
    const moreBtnCallback = (item1: any) => {
        if (item1.type === 'b_tab') {
            setIsOpen(true);
        }
    };
    const listA = [
        {
            tabName: t('a_tab'),
            bottomContent: t('a_desc'),
            hadFooterBtn: true,
            footerBtnText: t('a_btn'),
            footerBtnWinContent: <Win3 />,
            pc: 'https://websiteoss.ecoflow.com/upload/image/1724571229188/a1.jpg',
            h5: 'https://websiteoss.ecoflow.com/upload/image/1724571229711/b1.jpg',
        },
        {
            type: 'b_tab',
            tabName: t('b_tab'),
            bottomContent: t('b_desc'),
            hadFooterBtn: true,
            footerBtnText: t('a_btn'),
            footerBtnWinContent: <Win3 />,
            pc: 'https://websiteoss.ecoflow.com/upload/image/1724571229535/a2.jpg',
            h5: 'https://websiteoss.ecoflow.com/upload/image/1724571229361/b2.jpg',
            showMoreBtn: true,
            moreText: t('more_btn'),
        },
        {
            tabName: t('c_tab'),
            bottomContent: t('c_desc'),
            hadFooterBtn: true,
            footerBtnText: t('a_btn'),
            footerBtnWinContent: <Win3 />,
            pc: 'https://websiteoss.ecoflow.com/upload/image/1724571229002/a3.jpg',
            h5: 'https://websiteoss.ecoflow.com/upload/image/1724571228847/b3.jpg',
        },
    ];
    const [isOpen, setIsOpen] = useState(false);
    return (
        <div className={styles.TheComp}>
            <EfSpec />
            <EfSection hasAnimation={false} title={t('title')} />
            <EfTabSection list={listA} moreCallback={moreBtnCallback} gtm_list_name={t('title')} type="LROpacity" />
            {isOpen && (
                <EfModal
                    position="center"
                    open={isOpen}
                    className="TabA-Win1"
                    callback={() => {
                        setIsOpen(false);
                    }}
                >
                    <Win1 />
                </EfModal>
            )}
        </div>
    );
}
